export default __webpack_public_path__ + "static/media/IMG-20241210-WA0037.bd595211.jpg";